import React from 'react';
import { Box, CircularProgress, type CircularProgressProps } from '@mui/material';
import { SEARCE_COLORS } from '../../../theme';

export interface InlineSpinnerProps {
  /** Diameter in px */
  size?: number;
  thickness?: number;
  sx?: CircularProgressProps['sx'];
  /** Center inside a flex box (e.g. table area, dialog body) */
  centered?: boolean;
  centerMinHeight?: number | string;
}

/**
 * Standard MUI spinner for localized async UI: buttons, form fields, chips, small widgets.
 * Prefer {@link DashboardSectionSkeleton}, {@link TableSkeleton}, or route-level skeletons for initial page/table layout.
 */
export const InlineSpinner: React.FC<InlineSpinnerProps> = ({
  size = 20,
  thickness,
  sx,
  centered,
  centerMinHeight,
}) => {
  const t = thickness ?? (size <= 22 ? 4 : 3);
  const spinner = (
    <CircularProgress size={size} thickness={t} sx={{ color: SEARCE_COLORS.primary, ...sx }} />
  );
  if (centered) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          minHeight: centerMinHeight ?? size + 24,
        }}
      >
        {spinner}
      </Box>
    );
  }
  return spinner;
}
